/**
 * Shown when the browser cannot give us a WebGL context.
 *
 * The alternative — mounting the canvas anyway — is a black rectangle and no explanation,
 * which the app-shell spec explicitly forbids. `role="alert"` because this ends the
 * session rather than merely reporting progress.
 */

export function UnsupportedBrowser() {
  return (
    <div className="overlay">
      <div role="alert">
        <h1>This browser can’t run the game</h1>
        <p>
          Lab17 Labyrint needs WebGL to draw in 3D, and this browser isn’t providing it.
          Try updating to a newer version, opening the game in another browser, or
          enabling hardware acceleration in your browser’s settings.
        </p>
      </div>
    </div>
  );
}
